export default {
  FETCH_DATA: 'waiting_of_delivery_fetch_data',
  UPDATE_QUERY: 'waiting_of_delivery_update_query',
  LOAD_MORE_DATA: 'waiting_of_delivery_load_more_data',
  UPDATE_LOADING: 'waiting_of_delivery_update_loading',
  UPDATE_SELECTED: 'waiting_of_delivery_update_selected',
  UPDATE_SELECTED_EMPTYCONT: 'waiting_of_delivery_update_selected_emptycont',
  UPDATE_ONE_DATA: 'waiting_of_delivery_update_one_data',
};
